const initializeCities = document.getElementById('wo-cities');

if (initializeCities) {
    const milanButton = document.getElementById('milanoButton');
    const romeButton = document.getElementById('romaButton');
    const turinButton = document.getElementById('torinoButton');
    const parisButton = document.getElementById('parigiButton');

    milanButton.addEventListener('click', function () {
        redirectToAreas('Milano');
    });

    romeButton.addEventListener('click', function () {
        redirectToAreas('Roma');
    });

    turinButton.addEventListener('click', function () {
        redirectToAreas('Torino');
    });

    parisButton.addEventListener('click', function () {
        redirectToAreas('Paris');
    });

    // Translation file for areas
    document.addEventListener('DOMContentLoaded', function () {
        const path = window.location.pathname;
        const languageMatch = path.match(/^\/(en|fr|it)\//);
        const languageCode = languageMatch ? languageMatch[1] : 'it'; // default to Italian

        const translationsAll = {
            en: translationsEn,
            fr: translationsFr,
            it: translationsIt
        };

        const translations = translationsAll[languageCode] || translationsIt;

        function updateContent() {
            // Update text content based on language
            document.getElementById('title').textContent = translations.cities.title;

            document.getElementById('addressGeolocation').placeholder = translations.cities.searchPlaceholder;

            document.getElementById('milanoButton').textContent = translations.cities.milanoText;
            document.getElementById('romaButton').textContent = translations.cities.romaText;
            document.getElementById('torinoButton').textContent = translations.cities.torinoText;
            document.getElementById('parigiButton').textContent = translations.cities.parigiText;

            document.getElementById('modal-title-active').textContent = translations.cities.resultsText;
            document.getElementById('modal-btn-active').textContent = translations.cities.resultsButtonText;

            document.getElementById('modal-title-no').textContent = translations.cities.noResultsText;
            document.getElementById('modal-btn-no').textContent = translations.cities.noResultsButtonText;
        }

        updateContent();
    });

    // Wait for the window to load all scripts and resources
    window.addEventListener('load', function () {
        initGeolocation();
    });
}

function initGeolocation() {
    const addressInput = document.getElementById('addressGeolocation');
    if (!addressInput) return;

    const autocomplete = new google.maps.places.Autocomplete(addressInput, {
        types: ['geocode']
    });

    autocomplete.addListener('place_changed', async function () {
        const place = autocomplete.getPlace();

        if (!place.geometry || !place.geometry.location) {
            return;
        }

        const coordinates = {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
        };

        const isCovered = await checkCoveredArea(coordinates);

        if (isCovered) {
            // Show Active Address Modal
            var activeAddressModal = document.getElementById('activeAddressModal');
            var modal = new bootstrap.Modal(activeAddressModal);
            modal.show();
        } else {
            // Show No Address Modal
            var noAddressModal = document.getElementById('noAddressModal');
            var modal = new bootstrap.Modal(noAddressModal);
            modal.show();
        }

    });
}

async function checkCoveredArea(coordinates) {
    try {
        // Call the API function from endpoints.js
        const data = await getZoneByCoordinates(coordinates.lat, coordinates.lng);

        // Check if the data indicates coverage
        if (data && (data.zone || data.zones)) {
            return true;
        } else {
            return false;
        }
    } catch (error) {
        console.error("Error checking coverage area:", error);
        return false;
    }
}

function redirectToAreas(city) {
    const path = window.location.pathname;
    const languageMatch = path.match(/^\/(en|fr|it)\//);
    const languageCode = languageMatch ? languageMatch[1] : 'it'; // default to Italian

    let areaPath = '/aree/'; // default for Italian

    if (languageCode === 'fr') {
        areaPath = '/fr/zone-di-couverture/';
    } else if (languageCode === 'it') {
        areaPath = '/aree/';
    }

    if (city) {
        window.location.href = `${areaPath}?city=${encodeURIComponent(city)}`;
    } else {
        window.location.href = areaPath;
    }
}

function redirectToFunnel() {
    const path = window.location.pathname;
    const languageMatch = path.match(/^\/(en|fr|it)\//);
    const languageCode = languageMatch ? languageMatch[1] : 'it'; // default to Italian

    let funnelPath = '/come-funziona/';

    if (languageCode === 'fr') {
        funnelPath = '/fr/comment-ca-marche/';
    } else if (languageCode === 'en') {
        funnelPath = '/how-it-works/';
    }

    window.location.href = funnelPath;
}

